export const getMatcherNamesFromMergeValues = (markupMergeValues) =>
  Object.keys(markupMergeValues);
